import Fonts from './shared/Fonts';
import Countdown from './shared/Countdown';

export default function CumpleInfantil({ data, title }) {
  const d = data || {};
  const name = d.name || 'El festejado';
  const age = d.age;
  const date = d.date ? new Date(d.date) : null;

  const dateStr = date
    ? date.toLocaleDateString('es-PE', {
        weekday: 'long', day: 'numeric', month: 'long',
      })
    : null;

  const colors = {
    primary: '#ff6b9d',
    secondary: '#ffd93d',
    tertiary: '#6bcbff',
    green: '#95e06c',
    purple: '#b088ff',
    dark: '#2d2d5f',
  };

  const playful = "'Baloo 2', sans-serif";
  const body = "'Fredoka', sans-serif";

  return (
    <div
      className="min-h-screen w-full relative overflow-hidden"
      style={{
        background: `linear-gradient(135deg, #fff5f7 0%, #fff0e6 50%, #e6f4ff 100%)`,
      }}
    >
      <Fonts for="cumple" />

      {/* Confetti decorativo */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        {[
          { x: '8%', y: '12%', c: colors.primary, r: '15deg' },
          { x: '88%', y: '8%', c: colors.secondary, r: '-25deg' },
          { x: '15%', y: '70%', c: colors.tertiary, r: '45deg' },
          { x: '92%', y: '55%', c: colors.green, r: '-12deg' },
          { x: '5%', y: '40%', c: colors.purple, r: '60deg' },
          { x: '80%', y: '85%', c: colors.primary, r: '-30deg' },
          { x: '50%', y: '8%', c: colors.tertiary, r: '20deg' },
        ].map((s, i) => (
          <div
            key={i}
            className="absolute w-3 h-8 rounded-sm"
            style={{
              left: s.x, top: s.y,
              background: s.c,
              transform: `rotate(${s.r})`,
              opacity: 0.65,
            }}
          />
        ))}
      </div>

      {/* Hero */}
      <section className="relative px-6 pt-20 pb-16 sm:pt-28 sm:pb-20">
        <div className="max-w-3xl mx-auto text-center relative">
          {/* Burbujas de fondo */}
          <div className="absolute -top-4 -left-4 w-24 h-24 rounded-full blur-2xl opacity-60"
            style={{ background: colors.primary }} />
          <div className="absolute -top-4 -right-4 w-24 h-24 rounded-full blur-2xl opacity-60"
            style={{ background: colors.tertiary }} />

          <div className="relative">
            <div className="text-6xl sm:text-7xl mb-4 animate-bounce">🎈</div>

            <p
              className="text-sm sm:text-base tracking-[0.3em] uppercase mb-3"
              style={{ color: colors.primary, fontFamily: playful, fontWeight: 700 }}
            >
              ¡Estás invitado!
            </p>

            <h1
              className="text-5xl sm:text-7xl mb-4"
              style={{ fontFamily: playful, fontWeight: 800, color: colors.dark }}
            >
              {name}
            </h1>

            {age && (
              <div
                className="inline-block px-8 py-4 rounded-full mb-6 shadow-lg rotate-[-3deg]"
                style={{ background: colors.secondary }}
              >
                <span
                  className="text-3xl sm:text-4xl font-extrabold"
                  style={{ fontFamily: playful, color: colors.dark }}
                >
                  ¡Cumple {age}!
                </span>
              </div>
            )}

            <p
              className="text-lg sm:text-xl mt-4"
              style={{ fontFamily: body, color: colors.dark, opacity: 0.75 }}
            >
              {title || '¡Vamos a celebrar!'}
            </p>
          </div>
        </div>
      </section>

      {/* Cuenta regresiva */}
      {date && (
        <section className="px-6 py-10">
          <div
            className="max-w-2xl mx-auto rounded-3xl p-6 sm:p-8 shadow-xl"
            style={{ background: 'white', border: `3px dashed ${colors.primary}` }}
          >
            <p
              className="text-center text-sm tracking-widest uppercase mb-5"
              style={{ color: colors.primary, fontFamily: playful, fontWeight: 700 }}
            >
              Faltan
            </p>
            <Countdown target={date} accent={colors.primary} labelColor={colors.dark} />
          </div>
        </section>
      )}

      {/* Info */}
      <section className="px-6 py-12">
        <div className="max-w-2xl mx-auto grid sm:grid-cols-2 gap-5">
          {dateStr && (
            <div
              className="rounded-2xl p-6 text-center shadow-md rotate-[-1deg]"
              style={{ background: '#fff5f7', border: `2px solid ${colors.primary}` }}
            >
              <div className="text-4xl mb-2">📅</div>
              <p className="text-xs uppercase tracking-widest mb-1"
                style={{ color: colors.primary, fontFamily: playful, fontWeight: 700 }}>
                Cuándo
              </p>
              <p className="text-lg font-bold capitalize" style={{ fontFamily: body, color: colors.dark }}>
                {dateStr}
              </p>
              {d.time && (
                <p className="text-base mt-1" style={{ fontFamily: body, color: colors.dark, opacity: 0.7 }}>
                  {d.time}
                </p>
              )}
            </div>
          )}

          {d.place && (
            <div
              className="rounded-2xl p-6 text-center shadow-md rotate-[1.5deg]"
              style={{ background: '#e6f4ff', border: `2px solid ${colors.tertiary}` }}
            >
              <div className="text-4xl mb-2">🎉</div>
              <p className="text-xs uppercase tracking-widest mb-1"
                style={{ color: colors.tertiary, fontFamily: playful, fontWeight: 700 }}>
                Dónde
              </p>
              <p className="text-lg font-bold" style={{ fontFamily: body, color: colors.dark }}>
                {d.place}
              </p>
              {d.address && (
                <p className="text-sm mt-1" style={{ fontFamily: body, color: colors.dark, opacity: 0.7 }}>
                  {d.address}
                </p>
              )}
            </div>
          )}
        </div>
      </section>

      {/* Mensaje */}
      {d.description && (
        <section className="px-6 pb-16">
          <div className="max-w-xl mx-auto text-center bg-white rounded-3xl shadow-xl p-8 border-4 border-dotted"
            style={{ borderColor: colors.purple }}>
            <p className="text-xl sm:text-2xl leading-relaxed"
              style={{ fontFamily: body, color: colors.dark }}>
              {d.description}
            </p>
          </div>
        </section>
      )}

      <footer className="pb-10 text-center">
        <p className="text-xs opacity-70" style={{ color: colors.dark, fontFamily: body }}>
          Invitación creada con <b style={{ color: colors.primary }}>Go Fiesta</b>
        </p>
      </footer>
    </div>
  );
}